/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mainWindowSelect.vue?vue&type=template&id=cf061950&scoped=true&"
import script from "./mainWindowSelect.vue?vue&type=script&lang=js&"
export * from "./mainWindowSelect.vue?vue&type=script&lang=js&"
import style0 from "./mainWindowSelect.vue?vue&type=style&index=0&id=cf061950&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf061950",
  null
  
)

export default component.exports